import { lt, useDialog, useFeatureFlag } from '@mews/framework';
import { Banner, Button, Dialog, Link, SimpleList, SimpleListItem, Stack, Typography } from '@optimus-web/core';
import { FeatureFlag } from '@mews-commander/enums';

const financialIncentiveDays = 21;

interface RewardDialogProps {
    daysInOnboarding: number;
}

export const RewardBanner = ({ daysInOnboarding }: RewardDialogProps) => {
    const [{ onClose, active }, toggleDialog] = useDialog();

    const onboardingAuditFinancialIncentiveEnabled = useFeatureFlag(
        FeatureFlag.onboardingAuditFinancialIncentiveEnabled
    );
    const showFinancialIncentiveBanner =
        onboardingAuditFinancialIncentiveEnabled && daysInOnboarding <= financialIncentiveDays;

    if (!showFinancialIncentiveBanner) return null;

    return (
        <>
            <Banner
                primaryText={lt('OnboardingAuditTimelineBannerTitle')}
                secondaryText={
                    <Stack spacing="100" vertical>
                        {lt('OnboardingAuditTimelineBannerText', { count: financialIncentiveDays })}
                        <Typography as="div" textStyle="bodyMediumStrong">
                            <Link onClick={toggleDialog} variant="basic">
                                {lt('OnboardingAuditTimelineBannerLink')}
                            </Link>
                        </Typography>
                    </Stack>
                }
                variant="info"
            />
            <Dialog
                active={active}
                onClose={onClose}
                size="small"
                title={lt('OnboardingAuditTimelineDialogTitle')}
                footer={{
                    primary: (
                        <Button type="button" variant="primary" size="medium" onClick={onClose}>
                            {lt('Ok')}
                        </Button>
                    ),
                }}
            >
                <Stack spacing="400" vertical>
                    {lt('OnboardingAuditTimelineDialogSubtitle')}
                    <SimpleList ordered={false} spacing="300">
                        <SimpleListItem>{lt('OnboardingAuditTimelineDialogFirstListItem')}</SimpleListItem>
                        <SimpleListItem>{lt('OnboardingAuditTimelineDialogSecondListItem')}</SimpleListItem>
                        <SimpleListItem>{lt('OnboardingAuditTimelineDialogThirdListItem')}</SimpleListItem>
                        <SimpleListItem>
                            {lt('OnboardingAuditTimelineDialogFourthListItem', {
                                link: (text) => (
                                    <Link
                                        href="https://www.mews.com/en/mews-inner-circle"
                                        rel="noreferrer"
                                        target="_blank"
                                        variant="basic"
                                    >
                                        {text}
                                    </Link>
                                ),
                            })}
                        </SimpleListItem>
                    </SimpleList>
                    {lt('OnboardingAuditTimelineDialogNote')}
                </Stack>
            </Dialog>
        </>
    );
};
